// extracted by mini-css-extract-plugin
export default {"panel":"SignUpPage_panel__Y35Ac","terms":"SignUpPage_terms__M8S6N","select":"SignUpPage_select__W+tGv"};